import { gql } from '@apollo/client';

export const fetchRpcEndpointList = gql`
  query QueryRpcEndpointList($where: BrowserChainInput!) {
    browser_getRpc(where: $where)
  }
`;
